
import React from 'react'
import { BasePage as CngBasePage } from 'cng-web-lib'
import { ScopedCssBaseline } from '@mui/material';
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap';
import ABIEntrySummaryTranslationProvider from './contexts/ABIEntrySummaryTranslationContext';
import DutyCalculation from './component/DutyCalculation';

// const fullTitle = 'ABI Duty Calculation';
// const shortTitle = 'Settings';
// const BCrumb = [
//   { title: "ABI" },
//   { title: "Duty Calculation"},
// ];


function DutyCalculationPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
          <ScopedCssBaseline>
            <DutyCalculation showNotification={showSnackbar} {...props} />
          </ScopedCssBaseline>
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  );
}
export default DutyCalculationPage
